import React from 'react';

import MsgNetLoading from '../components/MsgNetLoading';
import ControlSelector from '../components/ControlSelector';
import ResultadoList from '../components/ResultadoList';
import CompeticionHeaderMenu from '../components/CompeticionHeaderMenu';
import GeneroSelector from '../components/GeneroSelector';
import SharePanel from '../components/SharePanel';
import TopHeaderMenu from '../components/TopHeaderMenu';
import { useNavigate, useParams } from 'react-router-dom';
import CONFIG from '../config';
import { applyDelta } from '../utils/wsDelta';

const RESULTADOS_MOSTRAR = 10;

class CompeticionScreenClass extends React.Component {
  constructor(props) {
    super(props);
    let resultados = [];
    let i = 0;
    while (i < 10) {
      resultados.push({ puesto: 0, nombre: '...', apellidos: '', dorsal: i, tiempo: 0, preload: true });
      i++;
    }
    this.state = {
      evento: null,
      competicion: null,
      sectores: [],
      controles: [],
      controlId: null,
      allResultados: [],
      resultados: resultados,
      generoSelectedIndex: 1,
      showSharePanel: false,
      wsConnected: false,
    };
    this.ws = null;
    this.wsReconnectTimer = null;
  }

  toogleSharePanel() {
    this.setState({ showSharePanel: !this.state.showSharePanel });
  }

  componentDidMount() {
    const { params } = this.props;
    const competicionId = parseInt(params.competicionId, 10);
    this.fetchInitData(competicionId);
    this.connectWS(competicionId);
  }

  fetchInitData(competicionId) {
    fetch(`${CONFIG.API_URL}/api/1.0/live/${competicionId}/init/`)
      .then(r => r.json())
      .then(data => {
        this.setState({
          competicion: data.competicion,
          evento: data.evento,
          sectores: data.sectores,
          controles: data.controles,
        });
      })
      .catch(err => console.error('live-init error:', err));
  }

  connectWS(competicionId) {
    if (this.ws) {
      this.ws.close();
    }
    const url = `${CONFIG.WS_URL}/ws/${competicionId}`;
    this.ws = new WebSocket(url);

    this.ws.onopen = () => {
      this.setState({ wsConnected: true });
      console.log('WS conectado:', url);
    };

    this.ws.onmessage = (event) => {
      const data = JSON.parse(event.data);
      if (data.tipo === 'update') {
        const allResultados = (data.resultados || []).map(r => ({
          ...r,
          ...r.controles,
        }));
        this.setState({ controles: data.controles || [], allResultados });
      } else if (data.tipo === 'delta') {
        this.setState(prev => ({
          controles: data.controles || prev.controles,
          allResultados: applyDelta(prev.allResultados, data.resultados || [], data.eliminados || []),
        }));
      }
    };

    this.ws.onclose = () => {
      this.setState({ wsConnected: false });
      // Reconectar en 3s
      this.wsReconnectTimer = setTimeout(() => this.connectWS(competicionId), 3000);
    };

    this.ws.onerror = (err) => {
      console.error('WS error:', err);
    };
  }

  componentWillUnmount() {
    if (this.wsReconnectTimer) clearTimeout(this.wsReconnectTimer);
    if (this.ws) this.ws.close();
  }

  _getResultadosFiltrados() {
    const { allResultados, controlId, generoSelectedIndex, competicion } = this.state;
    if (!allResultados.length || !controlId) return [];

    const n = (competicion && competicion.resultados_control_mostrar) || RESULTADOS_MOSTRAR;
    const puestoKey = `control_${controlId}_puesto`;
    const puestoSexoKey = `control_${controlId}_puesto_sexo`;

    let filtered;
    if (generoSelectedIndex === 1) {
      filtered = allResultados
        .filter(r => r[puestoKey] > 0)
        .sort((a, b) => a[puestoKey] - b[puestoKey]);
    } else if (generoSelectedIndex === 2) {
      filtered = allResultados
        .filter(r => r.sexo === 'M' && r[puestoSexoKey] > 0)
        .sort((a, b) => a[puestoSexoKey] - b[puestoSexoKey]);
    } else {
      filtered = allResultados
        .filter(r => r.sexo === 'F' && r[puestoSexoKey] > 0)
        .sort((a, b) => a[puestoSexoKey] - b[puestoSexoKey]);
    }
    return filtered.slice(0, n);
  }

  componentDidUpdate(prevProps, prevState) {
    const { controles, controlId } = this.state;

    // Seleccionar control automáticamente cuando llegan controles
    if (prevState.controles !== controles && controles.length) {
      const oldControles = prevState.controles;
      const conResultados = controles.filter(c => c.numero_llegados > 0);
      if (!oldControles || oldControles.length === 0) {
        // Carga inicial: ir al último control con datos
        if (conResultados.length) {
          const sorted = [...conResultados].sort((a, b) => a.distancia - b.distancia);
          this.setState({ controlId: sorted[sorted.length - 1].id });
        } else {
          const primero = controles.find(c => c.tipo !== 'META') || controles[0];
          this.setState({ controlId: primero.id });
        }
      } else if (conResultados.length && controlId) {
        // WS update: si hay un control más avanzado con datos, navegar a él
        const sorted = [...conResultados].sort((a, b) => a.distancia - b.distancia);
        const ultimoConDatos = sorted[sorted.length - 1];
        const controlActual = controles.find(c => parseInt(c.id, 10) === parseInt(controlId, 10));
        if (controlActual && ultimoConDatos.distancia > controlActual.distancia) {
          this.setState({ controlId: ultimoConDatos.id });
        }
      }
    }

    // Actualizar resultados filtrados cuando cambia controlId, género o allResultados
    if (
      prevState.controlId !== controlId ||
      prevState.generoSelectedIndex !== this.state.generoSelectedIndex ||
      prevState.allResultados !== this.state.allResultados
    ) {
      const resultados = this._getResultadosFiltrados();
      this.setState({ resultados });
    }
  }

  onClickBack() {
    this.props.navigate(`/${this.state.competicion.evento_id}`);
  }

  render() {
    const { competicion, evento, controles, sectores, controlId } = this.state;

    let control = null;
    if (controles && controlId) {
      control = controles.find(c => parseInt(c.id, 10) === parseInt(controlId, 10)) || null;
    }

    if (!competicion || competicion.visible === undefined) {
      return <MsgNetLoading />;
    }

    return (
      <div>
        <TopHeaderMenu
          onClickBack={this.onClickBack.bind(this)}
          onClickShare={this.toogleSharePanel.bind(this)}
          competicion={competicion}
          evento={evento}
        />
        <CompeticionHeaderMenu
          competicion={competicion}
          selected={1}
          evento={evento}
        />
        <div className="pt-24">
          <ControlSelector
            controlList={controles}
            competicion={competicion}
            controlId={controlId}
            navigateToControl={(id) => this.setState({ controlId: id })}
            showGeneroSelector={competicion.mostrar_filtro_sexo}
          />
          {this.state.resultados ? (
            controles.length > 0 && (
              <div>
                {competicion.mostrar_filtro_sexo && (
                  <GeneroSelector
                    selectedIndex={this.state.generoSelectedIndex}
                    toggleSexoTodos={() => this.setState({ generoSelectedIndex: 1 })}
                    toogleSexoMasculino={() => this.setState({ generoSelectedIndex: 2 })}
                    toogleSexoFemenino={() => this.setState({ generoSelectedIndex: 3 })}
                  />
                )}
                <ResultadoList
                  resultados={this.state.resultados}
                  competicion={competicion}
                  controlId={controlId}
                  controles={controles}
                  sectores={sectores}
                  control={control}
                />
              </div>
            )
          ) : (
            <MsgNetLoading />
          )}
        </div>
        {this.state.showSharePanel && (
          <SharePanel
            close={this.toogleSharePanel.bind(this)}
            url={`/competicion/${competicion.id}`}
            title={`Líderes de carrera en vivo en la prueba ${competicion.nombre} en ${evento.nombre}`}
          />
        )}
      </div>
    );
  }
}

function CompeticionScreen() {
  const navigate = useNavigate();
  const params = useParams();
  return <CompeticionScreenClass navigate={navigate} params={params} />;
}

export default CompeticionScreen;
